$(() => {
  const selectButtons = $('div.select-buttons');

  const initializeSelectButton = (select) => {
    $select = $(select);
    $select.find('button').on('click', () => {
      $this = $(event.target);
      $select.find('input').val($this.data('value'));
      $select.find('button').removeClass('active');
      $this.addClass('active');
    });
  };
  selectButtons.each((_, select) => initializeSelectButton(select));
});
